/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('welcomeModal', [function() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                '$timeout',
                'CmsContentService',
                'CookiesService',
                'UtilService',
                'WelcomeModalService',
                'IndexService',
                function (
                    $scope,
                    $timeout,
                    CmsContentService,
                    CookiesService,
                    UtilService,
                    WelcomeModalService,
                    IndexService
                ) {
                    var vm = this;
                    CmsContentService.retrieveCMSValue($scope, 'next', 'base:modals:benefits_next');
                    CmsContentService.retrieveCMSValue($scope, 'gotIt', 'base:modals:benefits_got_it');
                    vm.focusElement = UtilService.focusElement;

                    /**
                     * Once the modal template has loaded, make sure that the
                     * controls that are hidden via CSS are hidden from screen
                     * readers as well.
                     */
                    $timeout(function () {
                        vm.elem.find('.carousel .carousel-control').each(function () {
                            this.setAttribute('aria-hidden', 'true');
                        });
                    });

                    // Is true if there is a current animation, otherwise false, helps prevent the user
                    // from clicking to fast
                    var currentAnimation = false;
                    // Length of the animation. Slightly longer than transition time value (in CSS) to
                    // prevent any issues. The time is pulled from Bootstrap's carousel transition:
                    // .carousel-inner > .item
                    var animationTimer = 800;

                    $scope.carouselActiveIndex = 0;
                    $scope.siteTitle = UtilService.getSiteSetting('title');
                    $scope.bannerLogo = UtilService.getSiteSetting('banner_logo');
                    $scope.benefits = UtilService.getSiteSetting('benefits');
                    $scope.carouselLastIndex = $scope.benefits.length - 1;
                    $scope.displayWelcomeModalOnFirstVisit = WelcomeModalService.isWelcomeModalFeatureEnabled();
                    $scope.isCustomModalEnabled = false;

                    /**
                     * Displays the Welcome modal if the feature is enabled,
                     * if it hasn't been see on first visit and if it has not
                     * been disabled via url params `?modal_name=False`.
                     */
                    if ($scope.displayWelcomeModalOnFirstVisit) {
                        $scope.isDefaultModalEnabled = WelcomeModalService.isDefaultModalEnabled();
                        $scope.isCustomModalEnabled = WelcomeModalService.isCustomModalEnabled();
                        $scope.customModal = WelcomeModalService.getModalToDisplay();

                        if ($scope.isCustomModalEnabled) {
                            $scope.carouselLastIndex = $scope.customModal.data.length - 1;
                        }

                        var hasSeenBenefitsModalCookie = CookiesService.get('has_seen_benefits_modal');
                        if (!hasSeenBenefitsModalCookie && ($scope.isDefaultModalEnabled || $scope.isCustomModalEnabled)) {
                                IndexService.openModal('#modal-welcome');
                                CookiesService.set('has_seen_benefits_modal', 'true');
                        }
                    }

                    $scope.carouselNextSlide = function() {
                        // If an animation is not running, proceed to next slide.
                        // If there is an animation running, do nothing.
                        if (!currentAnimation) {
                            if ($scope.carouselActiveIndex === $scope.carouselLastIndex) {
                                // Close the modal
                                $('#modal-welcome').modal('toggle');
                            } else {
                                // Go to the next carousel slide
                                $scope.carouselActiveIndex++;
                                currentAnimation = true;
                                $timeout(function () {
                                    currentAnimation = false;
                                }, animationTimer);
                            }
                        }
                    };

                    $scope.carouselPreviousSlide = function() {
                        // If an animation is not running, proceed to previous slide.
                        // If there is an animation running, do nothing.
                        if (!currentAnimation) {
                            if ($scope.carouselActiveIndex === 0) {
                                // Close the modal
                                $('#modal-welcome').modal('toggle');
                            } else {
                                // Go to the next carousel slide
                                $scope.carouselActiveIndex--;
                                currentAnimation = true;
                                $timeout(function () {
                                    currentAnimation = false;
                                }, animationTimer);
                            }
                        }
                    };

                    // For accessibility purposes, return the focus to the
                    // carousel to read the new slide.

                    $('#modal-welcome').on('hidden.bs.modal', function () {
                        // Once the modal is hidden, reset to first slide
                        $scope.carouselActiveIndex = 0;
                    });
                }
            ],
            link: function(scope, elem, attrs, ctrl) {
                ctrl.elem = elem;
                elem.on('shown.bs.modal', function() {
                    /**
                     * Focus on this button when the modal opens, since this
                     * is the main control for the modal
                     */
                    var mainModalControl = elem.find('button[data-main-modal-control]');
                    ctrl.focusElement(mainModalControl);
                });
                elem.bind('keydown', function (event) {
                    if (event.key === 'ArrowLeft') {
                        scope.carouselPreviousSlide();
                    } else if (event.key === 'ArrowRight') {
                        scope.carouselNextSlide();
                    }
                });
            },
            template: require('@app/shared/modals/welcome/welcomeModalView.html'),
        };
    }]);
})(angular);
